module.exports = __webpack_public_path__ + "04fb61d1aa80c785292f01420c78e3ae.png";